export default __webpack_public_path__ + "img/47f338effeaceda79059e2e2c27c4bd5.jpeg";